import { render, staticRenderFns } from "./AllocationMismatch.vue?vue&type=template&id=794b6fb9"
import script from "./AllocationMismatch.vue?vue&type=script&lang=js"
export * from "./AllocationMismatch.vue?vue&type=script&lang=js"
import style0 from "./AllocationMismatch.vue?vue&type=style&index=0&id=794b6fb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports